/**
 * Input Validation Functions
 * @type {Object}
 */
SITE.Utils.Validate = {

    init: function() {
        "use strict";

        // Search Forms Validation
        SITE.Utils.Validate.validateSearch();

        // Notice: initially custom validation was used and then
        // we finally switched to jQuery Validation library.

        var form;

        SITE.validationDefaults();

        // Submit buttons of the forms needs to be triggered
        $("form[data-validate]").each(function() {

            // Enable jQuery Validation to this form
            $(this).validate();

            // Form's submit button should be triggered
            $(this).find("[data-submit]").click(function() {
                form = $(this).closest('form');

                if($(form).valid()) {
                    form.submit();
                }
            });

        });
    },

    /**
     * Validate search forms.
     */
    validateSearch: function() {
        "use strict";

        $('form#headerSearch').submit(function(event) {
            //event.preventDefault();

            var searchQueryInput = $('form#headerSearch input[name="s"]');
            var searchQuery = searchQueryInput.val().trim();

            if(searchQuery == "") {
                searchQueryInput.focus();
                return false;
            }

        });
    }
};